import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from '../../../axios/axios';

class DownloadFile extends Component {
  constructor(props) {
    super(props);
  }

  downloadFile = (id, title) => () => {
    axios.get(`/api/welsend/public/systemInfoFiles/${id}/file`, 
                {responseType: 'blob', contentType: 'application/pdf' })
        .then(res => {this.createDownloadFileLink(window.URL.createObjectURL(new Blob([res.data])), title) })
        .catch((error =>  {
            console.log(error);
        }))  
    }

 createDownloadFileLink = (url, title) => {
    let a = window.document.createElement('a')
    a.href = url
    a.setAttribute('download', title);
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
 }

  render() {
    return (
      <div className="download" onClick={this.downloadFile(this.props.data.id, this.props.data.fileName)}
                                id={this.props.data.id}>
        <span className="doc"></span>
        <span className="title">{this.props.data.displayName}</span>
      </div>
    )
  }
}

export default DownloadFile;

DownloadFile.propTypes = {
    data: PropTypes.object.isRequired,
}